import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { OnRampWidgetStep } from "@src/widgets/onboarding/classes/tours/OnRampWidgetTour/steps/OnRampWidgetStep"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"

export class OnRampWidgetTour extends BaseTour {
  name = ONBOARDING_TOURS.ON_RAMP_WIDGET

  steps = [new OnRampWidgetStep()]
}
